import React, { useEffect } from "react";
import "./App.css";
import AppRoutes from "./Routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { setUserRole } from "./Redux/slices/userSlice";

const App: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem("auth-access");
    if (token) {
      try {
        const decoded: { role: string } = jwtDecode(token);
        dispatch(setUserRole(decoded?.role));
      } catch (error) {
        localStorage.removeItem("auth-access");
        localStorage.removeItem("refresh-access");
        localStorage.removeItem("isAuthenticated");
      }
    }
  }, [dispatch]);
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        console.warn("User may be screen recording or switching tabs");
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  return (
    <div className="App">
      <div className="secure-content">
        <AppRoutes />
      </div>
    </div>
  );
};

export default App;
